export const imeiLookupModal = {
    columnDefinitions: [
        {
         caption: 'Wireless user', field: 'ctn', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
         enableSorting: false, enableFilter: false, cssClass: '', priority: 1, customTemplate: 'callBackAppNameCellTemplate'
        },
        {
          caption: 'IMEI', field: 'imei', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
          enableSorting: false, enableFilter: false, cssClass: '', priority: 3, customTemplate: 'callBackImei'
        },
        {
          caption: 'Status', field: 'status', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
          enableSorting: false, enableFilter: false, cssClass: '', priority: 2, customTemplate: 'callBackProfileStatus'
        }
      ]
}